/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetRegionsResponseAllOf,
    GetRegionsResponseAllOfFromJSON,
    GetRegionsResponseAllOfFromJSONTyped,
    GetRegionsResponseAllOfToJSON,
} from './GetRegionsResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    Region,
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
} from './Region';

/**
 * 
 * @export
 * @interface GetRegionsResponse
 */
export interface GetRegionsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetRegionsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetRegionsResponse
     */
    message: string;
    /**
     * 
     * @type {Array<Region>}
     * @memberof GetRegionsResponse
     */
    data: Array<Region>;
}

export function GetRegionsResponseFromJSON(json: any): GetRegionsResponse {
    return GetRegionsResponseFromJSONTyped(json, false);
}

export function GetRegionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRegionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(RegionFromJSON)),
    };
}

export function GetRegionsResponseToJSON(value?: GetRegionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(RegionToJSON)),
    };
}

